

export const MsgChannels = () => {
   // const {$,pm}:{$:$Channel, pm:ChannelPM} = useChannelPs()
    
    console.log('x)')
    return <div>  Channels goes here</div>
}
